<template>
  <div
    class="yhc-ef-item-list--item yhc-ef-item-list--item-content"
    v-if="kazaiData?.kazaiType"
  >
    <button
      type="button"
      @click.prevent.stop="() => removeKazai()"
      class="btn-close yhc-ef-item-list--item--delete-button"
      aria-label="Close"
    />
    <div class="yhc-ef-item-list--item--inner d-flex">
      <div class="kazai-image">
        <img
          style="max-height: 80px"
          v-if="kazaiData.kazaiType.thumbnail"
          :src="$core.$imgix.buildUrl(kazaiData.kazaiType.thumbnail)"
          alt=""
        />
      </div>
      <div class="kazai-description">
        <p class="kazai-name bold mb-4">
          {{ kazaiData.kazaiType.name }}
          <span
            v-if="kazaiData.kazaiType.displayNameFormEnabled"
            class="bold"
            >({{ kazaiData.userInputName }})</span
          >
        </p>
        <p class="mb-2 bold">
          運賃: ¥
          <span v-if="kazaiData.basePriceBySizeRank">{{
            kazaiData.basePriceBySizeRank.toLocaleString()
          }}</span>
          <span v-else>-</span>
        </p>
        <div
          v-if="
            kazaiData.totalPrice &&
            Object.keys(kazaiData.availableSelectedOptionsByServiceId).length !== 0
          "
          class="selected-options"
        >
          <p class="bold mb-1">オプション料金</p>
          <ul>
            <li
              v-for="(selections, sId) in kazaiData.availableSelectedOptionsByServiceId"
              class="selected-option-item"
            >
              <p
                v-for="(selection, oId) in selections"
                class="mb-1"
              >
                {{ selection.title }}: ¥{{ selection.price.toLocaleString() }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between pt-1">
      <div>
        <button
          type="button"
          @click.prevent="() => editKazai()"
          class="yhc-ef-item-list--item--modify-btn hover-fade"
          aria-label="修正"
        >
          修正
        </button>
      </div>
      <p class="bold text-right kazai-total-price">
        小計: ¥
        <span v-if="kazaiData.totalPrice">{{
          kazaiData.totalPrice.toLocaleString()
        }}</span>
        <span v-else>-</span>
      </p>
    </div>
    <div
      v-if="kazaiData.sizeErrorMessage"
      class="text-danger small bold alert alert-danger mt-1"
    >
      {{ kazaiData.sizeErrorMessage }}
    </div>
    <b-modal
      ref="editKazaiModal"
      title="運びたいお荷物の種類やサイズ、オプションを選択してください"
      size="md"
      dialog-class="yhc-ef-modal-dialog--kazaiForm"
      ok-only
      ok-title="戻る"
      ok-variant="outline-secondary"
      title-class="bg-light"
      class="yhc-modal"
      no-close-on-backdrop
      no-close-on-esc
    >
      <YhcEFKazaiDetailInput
        :subCategoryId="kazaiData.kazaiType.subCategory.id"
        :existing-kazai-data="kazaiData"
        @addKazai="(_kazaiData) => updateKazaiData(_kazaiData)"
      />
    </b-modal>
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import { YhcEFInputOneKazaiTypeDataObject } from '../../YhcEFInputOneKazaiTypeDataObject'
import YhcEFKazaiDetailInput from '../YhcEFKazaiDetailInput/YhcEFKazaiDetailInput.vue'

export default {
  components: { YhcEFKazaiDetailInput },
  props: {
    kazaiData: {
      type: Object as PropType<YhcEFInputOneKazaiTypeDataObject>,
      required: false,
    },
  },
  computed: {
    isContainUnavailableArea(): boolean {
      return !!this.kazaiData?.$efs?.$userInputData?.isContainUnavailableArea
    },
  },
  watch: {
    isContainUnavailableArea(unavailable: boolean) {
      if (unavailable) {
        this.$refs.editKazaiModal?.hide?.()
      }
    },
  },
  methods: {
    editKazai() {
      this.$refs.editKazaiModal.show()
    },
    updateKazaiData(kazaiData) {
      this.kazaiData.$efs.$userInputData.updateKazaiData(kazaiData)
      this.kazaiData.$efs.$userInputData.loadDeliveryPeakSeasonRules() // 繁忙期ルールを更新
      this.kazaiData.$efs.$userInputData.recalculateDeliveryDates()
      this.$refs.editKazaiModal.hide()
    },
    async removeKazai() {
      if (
        await $core.$toast.confirmDialog(
          `"${this.kazaiData.kazaiType.name}" を削除しますか？`,
        )
      ) {
        this.kazaiData.$efs.$userInputData.removeKazaiDataById(this.kazaiData.id)
        await this.kazaiData.$efs.$userInputData.recalculateDeliveryDates()
      }
    },
  },
}
</script>
